var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcDelete20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "l3nyuun2fa",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 14,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8 5.45v-.6a.8.8 0 0 1 .8-.8h2.8a.8.8 0 0 1 .8.8v.6H7.8zm-1.6 0v-.6a2.4 2.4 0 0 1 2.4-2.4h2.8a2.4 2.4 0 0 1 2.4 2.4v.6h2.4a.8.8 0 0 1 0 1.6h-.9v8.1a2.4 2.4 0 0 1-2.4 2.4H7.1a2.4 2.4 0 0 1-2.4-2.4v-8.1h-.9a.8.8 0 1 1 0-1.6h2.4zm.1 1.6v8.1a.8.8 0 0 0 .8.8h5.8a.8.8 0 0 0 .8-.8v-8.1H6.3zm1.4 2.7v3.5a.8.8 0 0 0 1.6 0v-3.5a.8.8 0 1 0-1.6 0zm3 3.5v-3.5a.8.8 0 0 1 1.6 0v3.5a.8.8 0 0 1-1.6 0z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#l3nyuun2fa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M0 0h20v20H0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDelete20);
export default __webpack_public_path__ + "static/media/ic-delete-20.7716504d981b26ac92d2e06d676d8f11.svg";
export { ForwardRef as ReactComponent };